import React from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import VersionChecker from "./components/common/VersionChecker";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import OrderPublicView from "./pages/OrderPublicView";
import "./styles/globals/colors.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          {/* Detector de versión antigua */}
          <VersionChecker />
          
          <Routes>
            {/* Ruta pública - Login */}
            <Route path="/login" element={<Login />} />
            
            {/* Ruta pública - Ver pedido por QR */}
            <Route path="/order/:orderId" element={<OrderPublicView />} />
            
            {/* Redirigir raíz al login */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            {/* Rutas protegidas - Dashboard con control de roles interno */}
            <Route 
              path="/dashboard/*" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />

            {/* Ruta 404 - Redirigir al login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          
          {/* Contenedor de notificaciones toast */}
          <ToastContainer
            position="bottom-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
